module.exports = __webpack_public_path__ + "static/magento_logo-bd3c8987f8cd58dc1ce0a85e7dbe075f.svg";